//EXTERNAL
import { generateFormatHtml } from "@picnicmedia/format-html-generator";
//HELPERS
import dom_to_image from "../../../../helpers/dom_to_image";
import { create_creative_clone } from "../../../../helpers/create_creative_clone";
//TYPES
import { ContextState } from "../../../../types/contextType";

export function createCleanFormatHtml(formatHtml: string): string {
  //
  // cleans format html of script and video tags so that it can be used by dom-to-image
  //
  // remove HTML <head> and <script> tags
  let cleanFormatHtml = formatHtml.split("/CSS -->")[1].split("<!-- CHUNK_NAME: Universal/Script_Start -->")[0];
  // completely remove pixel video tags
  cleanFormatHtml = cleanFormatHtml.replaceAll(`<video class="post-pixel-video" id="pixel-video" poster="pixel-video-poster.jpeg" muted playsinline>`, "");
  cleanFormatHtml = cleanFormatHtml.replaceAll(`<source type="video/mp4" src="pixel-video-original.mp4" />`, "");
  // this removes the first instance of </video> which is needed for removing closing video tag of pixel video element -
  // no knock on effects for formats without pixel video element (AF 14-07-23)
  cleanFormatHtml = cleanFormatHtml.replace(`</video>`, "");
  // update `<video` to `<img`
  cleanFormatHtml = cleanFormatHtml.replaceAll("<video", "<img");
  // update `poster=` attribute to `src=`
  cleanFormatHtml = cleanFormatHtml.replaceAll("poster=", "src=");
  // update trailing `</video` to closing image `/>`
  cleanFormatHtml = cleanFormatHtml.replaceAll("</video>", "/>");
  // remove image with empty src attribute from swipe creative
  cleanFormatHtml = cleanFormatHtml.replaceAll('<img id="swipe-stretch-bg-image" class="swipe-stretch-bg" src="" />', "");
  return cleanFormatHtml;
}

export async function getDomScreenshot(creative: ContextState): Promise<Blob> {
  try {
    //
    // create clone of creative object with missing text / assets replaced with placeholder data
    //
    let creativeClone = create_creative_clone(creative);
    //
    // generate format html string from Format Generator npm module
    //
    let formatHtml = (await generateFormatHtml(creativeClone)) as string;
    //
    // clean format html string by removing video elements and script tags as this breaks dom-to-image (AF 13-07-23)
    //
    let cleanFormatHtml = createCleanFormatHtml(formatHtml);
    //
    // insert parent invisible export png container into dom
    //
    let parentNode = document.getElementById("format-preview-container") as HTMLElement;
    let exportPngInvisibleContainer = document.createElement("div");
    exportPngInvisibleContainer.style.cssText = "opacity: 0; z-index: -999; position: absolute";
    exportPngInvisibleContainer.setAttribute("id", "export-png-invisible-container");
    parentNode.insertAdjacentElement("afterbegin", exportPngInvisibleContainer);
    //
    // insert child export png container into dom
    //
    let childNode = document.getElementById("export-png-invisible-container") as HTMLElement;
    let exportPngContainer = document.createElement("div");
    exportPngContainer.style.cssText = "height: 575px; width: 340px; margin: 5px; position: relative";
    exportPngContainer.setAttribute("id", "export-png-container");
    childNode.insertAdjacentElement("afterbegin", exportPngContainer);
    //
    // temporarily insert cleanFormatHtml into invisible export png container to take screenshot
    //
    exportPngContainer.innerHTML = cleanFormatHtml;
    //
    // now find and remove all video source elements since it's easier to access them as innerHTML
    //
    let allVideoSourceTags = exportPngContainer.getElementsByTagName("source");
    Array.from(allVideoSourceTags).map((sourceTag) => sourceTag.remove());
    //
    // create screenshot
    //
    let domScreenshot = await dom_to_image(exportPngContainer);
    //
    // remove invisible export png container from dom
    //
    exportPngInvisibleContainer.remove();
    //
    // return dom screenshot
    //
    return domScreenshot;
  } catch (error) {
    console.log("error", error);
    return error;
  }
}
